
import glstatment from "./glstatment"; 
import accountstatment from "./accountstatment";
import productstatment from "./productstatment";
import ctrreport from "./ctrreport";
import branchadjustmentreconchecking from "./branchadjustmentreconchecking";
import glaveragelastfridayquarter from "./glaveragelastfridayquarter";

export default {
    glstatment,
    accountstatment,
    productstatment,
    ctrreport,
    branchadjustmentreconchecking,
    glaveragelastfridayquarter
}